import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEIconCodes from '../../../../lib/oe-icon-codes';
import OEFNElement from '../../../elements/oe-flow-nav-elements';

export default class OEFNHelpAdvice extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            strings: {
                requirements_title: '',
                requirements_msg_1: '',
                requirements_msg_2: '',
                requirements_msg_3: '',
                requirements_msg_4: '',
                tutor_title: '',
                tutor_msg_1: '',
                tutor_msg_2: '',
                tutor_msg_3: ''
            }
        };

        this.updateLanguage = this.updateLanguage.bind(this);
    }

    componentWillReceiveProps(nextProps)   {
        if(nextProps.locStringPrefix !== this.props.locStringPrefix)  {
            this.updateLanguage(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLanguage(props)   {
        props = props || this.props;
        let si = this.oe.sharedInterface;
        this.setState({strings: {
            requirements_title: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_ga_requirements_title'),
            requirements_msg_1: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_ga_requirements_msg_1'),
            requirements_msg_2: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_ga_requirements_msg_2'),
            requirements_msg_3: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_ga_requirements_msg_3'),
            requirements_msg_4: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_ga_requirements_msg_4'),
            tutor_title:        si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_ga_tutor_title'),
            tutor_msg_1:        si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_ga_tutor_msg_1'),
            tutor_msg_2:        si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_ga_tutor_msg_2'),
            tutor_msg_3:        si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_ga_tutor_msg_3')
        }});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEFNElement.View>
                    <OEFNElement.Chapter
                        title={this.state.strings.requirements_title}
                    >
                        <OEFNElement.StdParagraphSubItem iconCode={OEIconCodes.helpView.dot} title={this.state.strings.requirements_msg_1} />
                        <OEFNElement.StdParagraphSubItem iconCode={OEIconCodes.helpView.dot} title={this.state.strings.requirements_msg_2} />
                        <OEFNElement.StdParagraphSubItem iconCode={OEIconCodes.helpView.dot} html={this.state.strings.requirements_msg_3} />
                        <OEFNElement.StdParagraphSubItem iconCode={OEIconCodes.helpView.dot} html={this.state.strings.requirements_msg_4} />
                    </OEFNElement.Chapter>

                    <OEFNElement.Chapter
                        title={this.state.strings.tutor_title}
                    >
                        <OEFNElement.StdParagraphSubItem iconCode={OEIconCodes.helpView.dot} title={this.state.strings.tutor_msg_1} />
                        <OEFNElement.StdParagraphSubItem iconCode={OEIconCodes.helpView.dot} title={this.state.strings.tutor_msg_2} />
                        <OEFNElement.StdParagraphSubItem iconCode={OEIconCodes.helpView.dot} html={this.state.strings.tutor_msg_3} />
                    </OEFNElement.Chapter>

                    <OEFNElement.Spacer height="1em" /*16px*//>
                </OEFNElement.View>
            </React.Fragment>
        );
    }
}

OEFNHelpAdvice.defaultProps = {
    moduleId:           '',
    locStringPrefix:    ''
};

OEFNHelpAdvice.propTypes = {
    moduleId:           PropTypes.string,
    locStringPrefix:    PropTypes.string
};